import { Component, OnInit } from '@angular/core';
import { DocNotificationService } from 'src/app/services/doc-notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DocNotification } from 'src/app/models/doc-notification';
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-doc-notification',
  templateUrl: './doc-notification.component.html',
  styleUrls: ['./doc-notification.component.css']
})
export class DocNotificationComponent implements OnInit {
  public documents:DocNotification[] = [];
  public loading = false;
  public doc:DocNotification = new DocNotification();
  public users:User[] = [];
  public expand:boolean = false;

  public actEditDocNot:boolean = true;
  public actAddDocNot:boolean = true;
  public actDeleteDocNot:boolean = true;

  constructor(private docServ:DocNotificationService, private modalService: NgbModal, private utl:UtilitiesService, private authService:AuthService, private toastr: ToastrManager, private userServ:UserService) { }

  ngOnInit() {
    this.getDocNot();
    this.userServ.getUsers().then(users => this.users = users);
    this.actEditDocNot = this.authService.can("update-document-notification");
    this.actDeleteDocNot = this.authService.can("destroy-document-notification");
    this.actAddDocNot = this.authService.can("store-document-notification");
  }

  getDocNot() {
    this.loading = true;
    this.docServ.getDocNotifications().then(documents => {
      this.documents = documents;
      this.loading = false;
    });
  }

  select(modal?, doc?:DocNotification) {
    this.doc = doc ? doc : new DocNotification();

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }

  updateDocNot() {
    this.loading = true;
    this.docServ.putDocNotification(this.doc).then(res => {
      this.getDocNot();
      this.modalService.dismissAll();
      this.toastr.successToastr('Actualizado correctamente', 'Bien');
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    });
  }

  storeDocNot() {
    this.loading = true;
    this.docServ.postDocNotification(this.doc).then(doc => {
      this.getDocNot();
      this.modalService.dismissAll();
      this.toastr.successToastr('Creado correctamente', 'Bien');
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    });
  }

  deleteDocNot() {
    this.loading = true;
    this.docServ.deleteDocNotification(this.doc).then(res => {
      this.getDocNot();
      this.modalService.dismissAll();
      this.toastr.successToastr('Eliminado correctamente', 'Bien');
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    });
  }
}
